import React, { type ReactNode } from "react";
import { SimpleGrid, Flex } from "@chakra-ui/react";
import { TextTitle } from "ui/text";
import { Section } from "components/section";
import { type BrandColor } from "contexts/color-theme";
import {
  ActivityIcon,
  AirplaneIcon,
  BabyIcon,
  BarsIcon,
  BookIcon,
  CarIcon,
  FirstAidKitIcon,
  GlobeIcon,
  WalletIcon,
} from "./icons";

export function Benefits() {
  return (
    <Section bg="white">
      <TextTitle size="xl" align="center" mobileAlign="center" title="Benefits" />

      <SimpleGrid
        mt={{ base: "biggest", md: "huge" }}
        columns={{ base: 1, md: 2, lg: 3 }}
        justifyContent="space-between"
        columnGap="biggest"
        rowGap={{ base: "biggest", md: "huge" }}
      >
        <BenefitItem
          color="green"
          icon={<WalletIcon />}
          title="Competitive compensation"
          description="We offer competitive compensation and meaningful equity. We also offer 401k for our US employees and retirement plans for our international employees."
        />

        <BenefitItem
          color="blue"
          icon={<GlobeIcon />}
          title="Hub & Remote friendly"
          description="Join our global team, either remotely or in one of our four in-person hubs. For those near a hub, enjoy complimentary lunches on Tuesdays and Thursdays."
        />

        <BenefitItem
          color="yellow"
          icon={<AirplaneIcon />}
          title="Flexible PTO"
          description="Downtime is just as important as on time and your teammates will support you while you relax and recharge."
        />

        <BenefitItem
          color="red"
          icon={<ActivityIcon />}
          title="Wellness"
          description="We offer wellness days each quarter."
        />

        <BenefitItem
          color="violet"
          icon={<FirstAidKitIcon />}
          title="Core benefits"
          description="For full-time US-based employees, we cover all health benefit premiums, 80% for dependents, and life insurance."
        />

        <BenefitItem
          color="green"
          icon={<BabyIcon />}
          title="Parental leave"
          description="We value and support the family planning process. We provide up to 16 weeks for parents."
        />

        <BenefitItem
          color="blue"
          icon={<BookIcon />}
          title="Professional development"
          description="We support employees for all learning resources needed to grow in their role (classes, books, conferences, etc)."
        />

        <BenefitItem
          color="green"
          icon={<BarsIcon />}
          title="Connectivity"
          description="We offer a $50 per month cell-phone or wifi connectivity stipend to all employees."
        />

        <BenefitItem
          color="yellow"
          icon={<CarIcon />}
          title="Commuter"
          description="Commuter benefits of $50 are offered to both employees who come into the offices and to remote workers working outside of their home."
        />
      </SimpleGrid>
    </Section>
  );
}

function BenefitItem({
  icon,
  color,
  title,
  description,
}: {
  icon: ReactNode;
  color: BrandColor;
  title: string;
  description: string;
}) {
  return (
    <Flex flexDir="column" align="start" justify="start">
      <Flex borderRadius="full" bg={`new.${color}.150`} align="center" justify="center" p="smallest">
        {icon}
      </Flex>

      <TextTitle size="xs" titleAs="h3" title={title} description={description} mt="small" />
    </Flex>
  );
}
